module.exports = __webpack_public_path__ + "img/f9_bg.8ab8cd7a.svg";